import { jsx as _jsx } from "react/jsx-runtime";
import { calculateAspectRatio, logoColors } from '@sphereon/ui-components.core';
import SSIPlaceholderLogo from '../SSIPlaceholderLogo';
const SSILogo = (props) => {
    const { logo, color = logoColors.default, size = 32, style } = props;
    return logo ? (_jsx("div", { style: {
            ...style,
            ...(logo?.dimensions && { aspectRatio: calculateAspectRatio(logo?.dimensions.width, logo?.dimensions.height) }),
            height: size,
            background: `url(${logo.uri})`,
            backgroundSize: 'cover',
        } })) : (_jsx(SSIPlaceholderLogo, { style: style, size: size, color: color }));
};
export default SSILogo;
